import React, { useState, useEffect } from 'react';
import { Button } from '../ui/Button';
import { Container } from '../ui/Container';

/**
 * CookieBanner - A premium cookie notification banner.
 * Persists user choice in localStorage to only show once.
 */
export function CookieBanner() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if user has already made a choice
        const consent = localStorage.getItem('mcp_cookies_consent');
        if (!consent) {
            // Delay showing the banner for a better UX
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('mcp_cookies_consent', 'accepted');
        setIsVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem('mcp_cookies_consent', 'rejected');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-[100] p-3 md:p-4 animate-in fade-in slide-in-from-bottom-5 duration-700">
            <Container size="measure">
                <div className="relative overflow-hidden rounded-xl border border-white/10 bg-slate-900/80 backdrop-blur-xl p-4 md:p-5 shadow-2xl">
                    {/* Decorative Background Glow */}
                    <div className="absolute -top-12 -right-12 h-24 w-24 rounded-full bg-accent/20 blur-[40px]" />
                    <div className="absolute -bottom-12 -left-12 h-24 w-24 rounded-full bg-blue-500/10 blur-[40px]" />

                    <div className="relative flex flex-col md:flex-row items-center justify-between gap-4">
                        <div className="flex-1 text-center md:text-left">
                            <h3 className="text-base font-semibold text-white mb-1">Privacy Notice</h3>
                            <p className="text-muted text-xs md:text-sm max-w-xl">
                                We use cookies to improve your experience. By accepting, you agree to our use of such cookies.
                                <a href="/privacy" className="text-accent hover:text-accent-light ml-1 font-medium transition-colors underline decoration-accent/30 underline-offset-4">
                                    Privacy Policy
                                </a>
                            </p>
                        </div>

                        <div className="flex flex-col sm:flex-row items-center gap-2 w-full md:w-auto">
                            <Button
                                variant="secondary"
                                size="sm"
                                onClick={handleDecline}
                                className="w-full sm:w-auto min-w-[90px] py-1.5"
                            >
                                Reject
                            </Button>
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={handleAccept}
                                className="w-full sm:w-auto min-w-[90px] py-1.5"
                            >
                                Accept
                            </Button>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
}
